import React, { useEffect } from 'react'
import { User } from 'shared'
import { Grid, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'

const EmailSentStep = ({ onMount }: { onMount: () => void }) => {
  const client = useQueryClient()
  const { email } = client.getQueryData(['user']) as User

  useEffect(() => {
    onMount()
  }, [])

  return (
    <Grid>
      <Typography fontSize="14px" variant="subtitle2">
        We sent an email to {email} with a link to reset your password.
      </Typography>
    </Grid>
  )
}

export default EmailSentStep
